<div style="text-align: -webkit-center;text-align: -moz-center; margin-top: 3rem;">
  <div class="card" style="margin: 16px; width: 40%;">
      <h1 style="margin-bottom: 0px; font-size: 3em; margin-top: 0;">DOWNLOAD DATA</h1>
  <form 
  style="padding-top: 5%;" 
  [formGroup]="registrationForm" 
  (ngSubmit)="download()">
  <div class= "inputForm">
      <select placeholder="Expermient" formControlName='experiment' style="height: 2.5rem;font-family: 'akzidenz-grotesk-bold';padding-left: 0.5rem; width: 20rem; font-size: 15px;">
        <option value="spq">SPQ</option>
        <option value="covid">Covid Questionnaire</option>
        <option value="tbw">TBW</option>
        <option value="memory">Memory Experiment</option>
        <option value="demographic">Demographic</option>
        <option value="sensory-adaptation">Sensory Adaptation</option>
        <option value="oddBall">Odd Ball</option>
      </select>
  </div>
  <div class= "buttons">
      <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
      <button class="button" *ngIf="!loading" [disabled]='loading' routerLinkActive="router-link-active" style="margin-top: 2rem"> Download</button>
  </div>
</form>
  <div class= "buttons">
  
  </div>
  <div>
  </div>
